/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_statuses_canceled_sogenactifcw = /** @type {(inputs: {}) => string} */ () => {
	return `Zrušeno`
};

const da_order_statuses_canceled_sogenactifcw = /** @type {(inputs: {}) => string} */ () => {
	return `Annulleret`
};

const de_order_statuses_canceled_sogenactifcw = /** @type {(inputs: {}) => string} */ () => {
	return `Storniert`
};

const en_order_statuses_canceled_sogenactifcw = /** @type {(inputs: {}) => string} */ () => {
	return `Annulée`
};

const es_order_statuses_canceled_sogenactifcw = /** @type {(inputs: {}) => string} */ () => {
	return `Cancelado`
};

const fr_order_statuses_canceled_sogenactifcw = /** @type {(inputs: {}) => string} */ () => {
	return `Annulée`
};

const hu_order_statuses_canceled_sogenactifcw = /** @type {(inputs: {}) => string} */ () => {
	return `Törölve`
};

const it_order_statuses_canceled_sogenactifcw = /** @type {(inputs: {}) => string} */ () => {
	return `Annullato`
};

const nl_order_statuses_canceled_sogenactifcw = /** @type {(inputs: {}) => string} */ () => {
	return `Geannuleerd`
};

const pl_order_statuses_canceled_sogenactifcw = /** @type {(inputs: {}) => string} */ () => {
	return `Anulowane`
};

const pt_order_statuses_canceled_sogenactifcw = /** @type {(inputs: {}) => string} */ () => {
	return `Cancelado`
};

const sv_order_statuses_canceled_sogenactifcw = /** @type {(inputs: {}) => string} */ () => {
	return `Avbruten`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_statuses_canceled_sogenactifcw = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_statuses_canceled_sogenactifcw(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_statuses_canceled_sogenactifcw", locale)
	if (locale === "cs") return cs_order_statuses_canceled_sogenactifcw(inputs)
	if (locale === "da") return da_order_statuses_canceled_sogenactifcw(inputs)
	if (locale === "de") return de_order_statuses_canceled_sogenactifcw(inputs)
	if (locale === "en") return en_order_statuses_canceled_sogenactifcw(inputs)
	if (locale === "es") return es_order_statuses_canceled_sogenactifcw(inputs)
	if (locale === "fr") return fr_order_statuses_canceled_sogenactifcw(inputs)
	if (locale === "hu") return hu_order_statuses_canceled_sogenactifcw(inputs)
	if (locale === "it") return it_order_statuses_canceled_sogenactifcw(inputs)
	if (locale === "nl") return nl_order_statuses_canceled_sogenactifcw(inputs)
	if (locale === "pl") return pl_order_statuses_canceled_sogenactifcw(inputs)
	if (locale === "pt") return pt_order_statuses_canceled_sogenactifcw(inputs)
	return sv_order_statuses_canceled_sogenactifcw(inputs)
};
export { order_statuses_canceled_sogenactifcw as "order_statuses.canceled_sogenactifcw" }